<div class="attributes">
   {{contents}}
</div>